import { useSearchParams } from 'react-router-dom';

/**
 * True when the URL carries `?training` — the course link. Not remembered: every
 * screen of the simulator lives on this one URL, and the browser's Back keeps
 * the param, so a visitor without it is always sent home. The flag hides the UI
 * only; the public endpoints have their own backend kill switch.
 */
export function useSimulatorFlag(): boolean {
  const [searchParams] = useSearchParams();
  return searchParams.has('training');
}
